/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.privacy.center.rpc.DprPublicRpc
 */

export const getConfigurationBySlugRpc = {
  serviceName: 'com.hubspot.privacy.center.rpc.DprPublicRpc',
  rpcName: 'getConfigurationBySlug',
  auth: 'external',
  fingerprint: 'rJKarpUo0vl1N1wn_8FtFT-SYmBLyRQX',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const verifyTokenRpc = {
  serviceName: 'com.hubspot.privacy.center.rpc.DprPublicRpc',
  rpcName: 'verifyToken',
  auth: 'external',
  fingerprint: '8VNUPYCzNGWyR9yRdN66_j-SYmBLyRQX',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const submitDprRequestRpc = {
  serviceName: 'com.hubspot.privacy.center.rpc.DprPublicRpc',
  rpcName: 'submitDprRequest',
  auth: 'external',
  fingerprint: 'rF95Oe6_2BAe8hrF6AtwyD-SYmBLyRQX',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const requestContactExportRpc = {
  serviceName: 'com.hubspot.privacy.center.rpc.DprPublicRpc',
  rpcName: 'requestContactExport',
  auth: 'external',
  fingerprint: 'wO85fTsbmsnaXm0RSIatmD-SYmBLyRQX',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const requestContactDeletionTokenRpc = {
  serviceName: 'com.hubspot.privacy.center.rpc.DprPublicRpc',
  rpcName: 'requestContactDeletionToken',
  auth: 'external',
  fingerprint: 'G7nHT5xhUU3aXm0RSIatmD-SYmBLyRQX',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const confirmContactDeletionRpc = {
  serviceName: 'com.hubspot.privacy.center.rpc.DprPublicRpc',
  rpcName: 'confirmContactDeletion',
  auth: 'external',
  fingerprint: 'wO85fTsbmsnaXm0RSIatmD-SYmBLyRQX',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};